module.exports = __webpack_public_path__ + "b6b3e21c90d5f27021d5bf09d78df4c2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/blanket-plum.png
// module id = 1238
// module chunks = 0